import React, { useState, useEffect, MouseEvent } from 'react'
import { useHistory } from 'react-router-dom'
import ViewProps from '../types/ViewProps'
import QuestionState from '../types/QuestionState'
import Modal from './Modal'
import Typed, { Segment } from './Typed'

interface Match {
	[key: string]: number | undefined
}

export default ({ data, entries }: ViewProps) => {
	const q1 = data!.filter(o => o.type === "q1answer")
	const q2 = data!.filter(o => o.type === "q2answer")

	const [ state, setState ] = useState<QuestionState>({
		showModal: false,
		questionSet: q1,
		currentChoice: 'q1answer',
		q1answer: '',
		q2answer: '',
	})

	const matches: Match = {
		'profile': undefined,
		'program': undefined,
	}

	if (state.q1answer && state.q2answer && entries) {
		data!.filter(o => o.type === "program" || o.type === "profile").forEach(p => {
			const result = p.validFor!.find(r => r.q1answer === state.q1answer && r.q2answer === state.q2answer)

			if (result !== null && typeof result !== "undefined") {
				const entry = entries.find(e => e.id === parseInt(p.id as string, 10))

				if (entry) {
					matches[entry.type] = entry.id
				}
			}
		})
	}

	const handleModal = (event: MouseEvent<HTMLDivElement>, type: string) => {
		const nextState: QuestionState = { ...state, showModal: true, currentChoice: type, }

		if (type === 'q1answer') {
			nextState.questionSet = q1
			nextState.q1answer = ''
			nextState.q2answer = ''
		}
		else {
			nextState.questionSet = q2!.filter(o => o.validFor!.flatMap(x => [(x as any).q1answer]).includes(state.q1answer))
		}
		setState(nextState)
	}

	const handleChoice = (choice: string) => {
		setState({ ...state, showModal: false, [state.currentChoice]: choice })
	}

	// https://gist.github.com/andjosh/6764939#gistcomment-2404310
	const scrollTo = function(to: number, duration: number) {
		const
		element = document.scrollingElement || document.documentElement,
		start = element.scrollTop,
		change = to - start,
		startDate = +new Date(),
		// t = current time
		// b = start value
		// c = change in value
		// d = duration
		easeInOutQuad = function(t:number, b:number, c:number, d:number) {
			t /= d/2;
			if (t < 1) return c/2*t*t + b;
			t--;
			return -c/2 * (t*(t-2) - 1) + b;
		},
		animateScroll = function() {
			const currentDate = +new Date();
			const currentTime = currentDate - startDate;
			element.scrollTop = easeInOutQuad(currentTime, start, change, duration);
			if(currentTime < duration) {
				requestAnimationFrame(animateScroll);
			}
			else {
				element.scrollTop = to;
			}
		};
		animateScroll();
	};

	if (window.innerWidth < 500 && state.q1answer !== '' && state.q2answer === '') {
		scrollTo(300, 500)
	}

	let history = useHistory()
	const [ navigating, setNavigating ] = useState<boolean>(false)
	function handleClick() {
		setNavigating(true)
		setTimeout(() => {
			const header = document.querySelector('#quiz-root') as HTMLElement
			if (header && window.innerWidth < 500) {
				window.scrollTo(0, header.offsetTop)
			}
			history.push(`/result/${matches.profile}/${matches.program}`);
		}, 900)
	}

	return (
		<div className={"quiz-wrapper questions" + (state.showModal ? ' modal-visible' : '') + (navigating ? ' navigating' : '')}>
			<div className="graphic-shape" />
			<div className="graphic-eye" />
			<div className="quiz-content-wrapper">
				<div className="quiz-content">
					<div className="question" onClick={e => handleModal!(e, 'q1answer')}>
						<div>
							<h1><Typed>My background is&hellip;</Typed></h1>
							<div className={`answer${state.currentChoice === 'q1answer' ? ' active' : ''}`}>
								{state.q1answer}
							</div>
						</div>
						{state.q1answer === '' && state.showModal && (
							<Modal choices={state.questionSet} onChoice={handleChoice} />
						)}
					</div>

					{state.q1answer && (
						<div className="question" onClick={e => handleModal!(e, 'q2answer')}>
							<div>
								<h1><Typed>My dream is to&hellip;</Typed></h1>
								<div className={`answer${state.currentChoice === 'q2answer' ? ' active' : ''}`}>
									{state.q2answer}
								</div>
							</div>
							{state.showModal && (
								<Modal choices={state.questionSet} onChoice={handleChoice} />
							)}
						</div>
					)}

					{state.q1answer && state.q2answer && (
						<div onClick={handleClick} className='nav-link'>next</div>
					)}
				</div>
			</div>
		</div>
	)
}
